export const EMPTY_VALUE = "---";
export const EMPTY_VALUE_SHORT = "--";
